export default __webpack_public_path__ + "static/media/no-items-gif.297bbee0.gif";